export default __webpack_public_path__ + "static/media/NP_logo_short_2.be65a257.png";